/* eslint-disable react/prop-types */
import classes from "./composed-view-four.module.scss";
import Label from "@/components-library/widgets/label";
import Button from "@/components-library/widgets/button";
import Flex from "@/components-library/layout/flex";
import Grid from "@/components-library/layout/grid";

function ComposedViewFour({
  title,
  content,
  image,
  button,
  hyperLinks,
  onClick,
}) {
  return (
    <Grid columns="1fr 1fr" className={classes.container}>
      <Flex
        align="flex-start"
        direction="column"
        justify="center"
        className={classes.subContainerLeft}
      >
        <Label
          weight="bold"
          tag="h2"
          color="secondary"
          align="start"
          className={classes.title}
        >
          {title}
        </Label>
        <Label
          align="start"
          size="md"
          color="secondary"
          className={classes.content}
        >
          {content}
        </Label>

        {hyperLinks?.length > 0 &&
          hyperLinks.map(({ title, link }) => (
            <Flex
              key={title}
              align="flex-start"
              direction="row"
              justify="flex-start"
              className={classes.link}
            >
              <Label
                color="secondary"
                align="start"
                weight="bold"
                onClick={() => onClick(link)}
              >
                {title}
              </Label>

              <img
                src={"/images/icons/cta-arrow.svg"}
                alt="link"
                className={classes.arrow}
                onClick={() => onClick(link)}
              />
            </Flex>
          ))}

        <Button
          onClick={() => onClick(button.link)}
          size="sm"
          color="primary"
          className={classes.button}
        >
          {button.title}
        </Button>
      </Flex>
      <Flex
        align="flex-start"
        direction="column"
        justify="flex-start"
        className={classes.subContainerRight}
      >
        <img src={image} alt="Logo" className={classes.image} />
      </Flex>
    </Grid>
  );
}

export default ComposedViewFour;
